// @ts-nocheck
import ReactDOM from 'react-dom';

export interface LoaderCubeProps {
  isLoading: boolean;
  children?: React.ReactElement;
}

export const LoaderCube = (props: LoaderCubeProps) => {
  const { isLoading, children } = props;
  if (!isLoading) return <>{children}</>;

  const portalNode =
    document.getElementById('loader-root') || document.createElement('div');

  return ReactDOM.createPortal(
    <div className="LoaderCube-overlay">
      <div className="LoaderCube-spinner-box">
        <div className="LoaderCube-configure-border-1">
          <div className="LoaderCube-configure-core-1"></div>
        </div>
        <div className="LoaderCube-configure-border-2">
          <div className="LoaderCube-configure-core-2"></div>
        </div>
      </div>
    </div>,
    portalNode
  );
};

export default LoaderCube;
